import { ROUTES } from '@/constants/routes'

export default function checkPermissions({
    next, store, permissionsStore, to, router,
}) {
    const { meta = {} } = to
    const { permission, reference } = meta

    if (reference === ROUTES.manageOffers || reference === ROUTES.manageRequests) {
        return store.isVendor
            ? next()
            : router.push({ name: ROUTES.notFound })
    }

    if (store.isVendor) {
        switch (reference) {
        case ROUTES.manageNumbers:
        case ROUTES.managePools:
            return next()
        case ROUTES.manageCampaigns:
        case ROUTES.detailCampaigns:
        case ROUTES.manageTrafficSources:
        case ROUTES.detailTrafficSource:
        case ROUTES.manageIntegrations:
        case ROUTES.googleAdsIntegration:
        case ROUTES.googleAdsIntegrationTrafficSource:
        case ROUTES.facebookAdsIntegration:
        case ROUTES.facebookAdsIntegrationTrafficSource:
        case ROUTES.facebookAdsIntegrationTrafficSourceEventLogs:
        case ROUTES.manageLeads:
            return permissionsStore.permissions.trafficSources.view
                ? next()
                : router.push({ name: ROUTES.notFound })
        }
    }

    if (store.isBuyer) {
        if (reference === ROUTES.manageDestinations) {
            return next()
        }

        if (reference === ROUTES.disputes && permissionsStore.permissions.disputes.view) {
            return next()
        }
    }

    if (!store.isWorkspaceOwner && !permissionsStore.checkPermissionByName(permission)) {
        return router.push({ name: ROUTES.notFound })
    }

    next()
}
